import DynamicForm from './components/DynamicForm';
import FormField from './components/FormField';
import * as validators from './components/validators';
import './styles/formStyles.css';

export default DynamicForm;

export { DynamicForm, FormField, validators };

export const FormulaireDynamique = {
  DynamicForm,
  FormField,
  validators
};